export default __webpack_public_path__ + "static/media/qs-icon.b51407b7.svg";